import { useMutation, useQuery } from 'react-query';

import { documentApi } from '../api';
import { FailedGptRequestStatuses, GptRequestStatuses } from '../constants/gptRequestStatuses';

import recordKeys from './models/record/keys';
import { camelCaseApiResponse } from './util';

export const GptRequestTerminalStatuses = [
  GptRequestStatuses.Completed,
  GptRequestStatuses.Published,
  GptRequestStatuses.Cancelled,
  GptRequestStatuses.Deleted,
  ...FailedGptRequestStatuses
];

/* QUERIES
========================================================= */
export const useGptRequest = ({ gptRequestId, pollInterval = 1500, options = {} }) => useQuery(
  recordKeys.gptRequest(gptRequestId),
  () => camelCaseApiResponse(() => documentApi.getGptRequest(gptRequestId)),
  {
    enabled: !!gptRequestId,
    refetchInterval: data => (GptRequestTerminalStatuses.includes(data?.status) ? false : pollInterval),
    ...options
  }
);

/* MUTATIONS
========================================================= */
export const useExtractDocumentExpirations = (options = {}) => useMutation(
  ({ documentIds }) => camelCaseApiResponse(() => documentApi.extractDocumentExpirations(documentIds)),
  options
);
